import {expectOneOf, HttpClient, POST, ServerValidationResult} from '@raison/network-facade';
import {AccountId} from '@raison/types';
import BigNumber from 'bignumber.js';
import {array, partial, string} from 'io-ts';
import {CryptoCurrencyType} from '~/entities/currencies';
import {TransactionHolderSchema} from '~/entities/operations-crypto';
import {TwoFaProvider} from '~/features/two-factor';
import {TrTxId} from '../model/TrTx';

export function submitTravelRuleConfirm(
    http: HttpClient,
    {
        accountId,
        accountType,
        ...data
    }: {
        accountId: AccountId;
        accountType: CryptoCurrencyType;
        trtId: TrTxId;
        fee: BigNumber;
        retry: boolean;
        provider: TwoFaProvider;
    }
) {
    const url = (() => {
        switch (accountType) {
            case 'crypto':
                return `v1/operations/${accountId}/send_crypto_tr/confirm`;
            case 'stablecoin':
                return `v1/operations/${accountId}/send_token_tr/confirm`;
        }
    })();

    const body = {
        trt_id: data.trtId,
        fee: data.fee.toNumber(),
        repeated_event: data.retry,
        two_fa_provider: data.provider.kind,
        ...(data.provider.kind === 'sms'
            ? {
                  verificationMethod: data.provider.method,
                  device_id: window.appDeviceId,
                  app_version: window.appVersion,
              }
            : null),
    };

    return http(url, POST(body)).then(
        expectOneOf({
            200: TransactionHolderSchema,
            201: TransactionHolderSchema,
            400: ServerValidationResult.createCodec(
                partial({
                    fee: array(string),
                    trt_id: array(string),
                    two_fa_provider: array(string),
                })
            ),
            401: null,
        })
    );
}
